import React from "react";
import { CustomerFormInput } from "../../api/customers";

const UFS = [
  "AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA", "MT", "MS", "MG", "PA", "PB",
  "PR", "PE", "PI", "RJ", "RN", "RS", "RO", "RR", "SC", "SP", "SE", "TO",
];

/**
 * Campos de cadastro de cliente — o mesmo conjunto de campos é usado tanto no cadastro (Novo
 * cliente) quanto na edição, pra não ter formulário incompleto/divergente entre os dois fluxos.
 */
export function CustomerFormFields({
  value,
  onChange,
}: {
  value: CustomerFormInput;
  onChange: (patch: Partial<CustomerFormInput>) => void;
}) {
  return (
    <div className="row g-3">
      <div className="col-12 col-sm-8">
        <label className="form-label" style={{ fontSize: 12 }}>
          Razão social / nome
        </label>
        <input
          className="form-control"
          value={value.razaoSocial}
          onChange={(e) => onChange({ razaoSocial: e.target.value })}
          placeholder="Ex.: Padaria Aurora ME"
        />
      </div>
      <div className="col-12 col-sm-4">
        <label className="form-label" style={{ fontSize: 12 }}>
          Nome fantasia
        </label>
        <input className="form-control" value={value.nomeFantasia ?? ""} onChange={(e) => onChange({ nomeFantasia: e.target.value })} />
      </div>
      <div className="col-12 col-sm-6">
        <label className="form-label" style={{ fontSize: 12 }}>
          CNPJ / CPF
        </label>
        <input
          className="form-control"
          value={value.cnpjCpf}
          onChange={(e) => onChange({ cnpjCpf: e.target.value })}
          placeholder="00.000.000/0000-00"
        />
      </div>
      <div className="col-12 col-sm-3">
        <label className="form-label" style={{ fontSize: 12 }}>
          Tipo
        </label>
        <select className="form-select" value={value.personType} onChange={(e) => onChange({ personType: e.target.value as "PF" | "PJ" })}>
          <option value="PJ">Pessoa jurídica</option>
          <option value="PF">Pessoa física</option>
        </select>
      </div>
      <div className="col-12 col-sm-3">
        <label className="form-label" style={{ fontSize: 12 }}>
          Telefone
        </label>
        <input className="form-control" value={value.phone ?? ""} onChange={(e) => onChange({ phone: e.target.value })} />
      </div>
      <div className="col-12">
        <label className="form-label" style={{ fontSize: 12 }}>
          E-mail para cobrança
        </label>
        <input
          type="email"
          className="form-control"
          value={value.email}
          onChange={(e) => onChange({ email: e.target.value })}
          placeholder="financeiro@empresa.com.br"
        />
      </div>

      <div className="col-12 mt-2">
        <strong style={{ fontSize: 12.5 }}>Endereço</strong>
      </div>
      <div className="col-12 col-sm-3">
        <label className="form-label" style={{ fontSize: 12 }}>
          CEP
        </label>
        <input className="form-control" value={value.cep ?? ""} onChange={(e) => onChange({ cep: e.target.value })} placeholder="00000-000" />
      </div>
      <div className="col-12 col-sm-6">
        <label className="form-label" style={{ fontSize: 12 }}>
          Logradouro
        </label>
        <input className="form-control" value={value.logradouro ?? ""} onChange={(e) => onChange({ logradouro: e.target.value })} />
      </div>
      <div className="col-12 col-sm-3">
        <label className="form-label" style={{ fontSize: 12 }}>
          Número
        </label>
        <input className="form-control" value={value.numero ?? ""} onChange={(e) => onChange({ numero: e.target.value })} />
      </div>
      <div className="col-12 col-sm-4">
        <label className="form-label" style={{ fontSize: 12 }}>
          Complemento
        </label>
        <input className="form-control" value={value.complemento ?? ""} onChange={(e) => onChange({ complemento: e.target.value })} />
      </div>
      <div className="col-12 col-sm-4">
        <label className="form-label" style={{ fontSize: 12 }}>
          Bairro
        </label>
        <input className="form-control" value={value.bairro ?? ""} onChange={(e) => onChange({ bairro: e.target.value })} />
      </div>
      <div className="col-12 col-sm-3">
        <label className="form-label" style={{ fontSize: 12 }}>
          Cidade
        </label>
        <input className="form-control" value={value.cidade ?? ""} onChange={(e) => onChange({ cidade: e.target.value })} />
      </div>
      <div className="col-12 col-sm-1">
        <label className="form-label" style={{ fontSize: 12 }}>
          UF
        </label>
        <select className="form-select" value={value.uf ?? ""} onChange={(e) => onChange({ uf: e.target.value })}>
          <option value="">—</option>
          {UFS.map((uf) => (
            <option key={uf} value={uf}>
              {uf}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

export const BLANK_CUSTOMER_FORM: CustomerFormInput = {
  razaoSocial: "",
  nomeFantasia: "",
  cnpjCpf: "",
  personType: "PJ",
  email: "",
  phone: "",
  cep: "",
  logradouro: "",
  numero: "",
  complemento: "",
  bairro: "",
  cidade: "",
  uf: "",
};
